import { Info } from '@mui/icons-material'
import { Chip, IconButton, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { enabledFeatures } from 'config/env'
import { selectFacet, unSelectFacet, resetFacetFilters } from 'store/actions/facets'
import { changeSearchText } from 'store/actions/search'

const Pills = ({
  items,
  areRemovable = true,
  selectOnClick = false,
  renderInfoSection = false
}) => {
  const dispatch = useDispatch()
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const handleClick = (id, name, facetType) => {
    if (selectOnClick) {
      dispatch(resetFacetFilters())
      dispatch(changeSearchText(''))
      dispatch(selectFacet({ id, name, facetType }))
    } else {
      dispatch(unSelectFacet({ id, facetType }))
    }
  }

  const getChipClassName = (name, facetType) => {
    if (!enabledFeatures.includes('FUNDER_PILLS_COLORING')) {
      return 'profile-pill profile-pill--default'
    }

    if (facetType === 'activityOption' && name === t.activities.grantmaking) {
      return 'profile-pill profile-pill--grantmaking'
    }

    const facetTypes = ['causes', 'regions', 'populations', 'internationals']
    if (facetType && facetTypes.includes(facetType)) {
      return `profile-pill profile-pill--${facetType}`
    }

    return 'profile-pill profile-pill--default'
  }

  return (
    <div>
      {!!renderInfoSection && (
        <Tooltip
          title={
            <div className="profile-tags-list-info-tip">
              <p>{t.funder.toolTip}</p>
              <p>{t.funder.toolTipDescription}</p>
            </div>
          }
          placement="left-start"
        >
          <IconButton className="profile-tags-list-info">
            <Info aria-label="Info" />
          </IconButton>
        </Tooltip>
      )}
      <div className="profile-tags-list">
        {items.map(({ id, name, facetType, isFilter }) => {
          if (!selectOnClick || isFilter) {
            return (
              <Chip
                key={`${facetType}-${id}`}
                className={getChipClassName(name, facetType)}
                onClick={() => handleClick(id, name, facetType)}
                label={name}
                onDelete={areRemovable ? () => handleClick(id, name, facetType) : undefined}
              />
            )
          } else {
            return (
              <Chip
                key={id}
                className={getChipClassName(name, facetType)}
                label={name}
                onDelete={areRemovable ? () => handleClick(id, name, facetType) : undefined}
              />
            )
          }
        })}
      </div>
    </div>
  )
}

export default Pills
